<template>
  <section class="seccion modulos">
    <div class="modulos__tabs is-hidden-touch">
      <div
        class="tab"
        v-for="(tab, $index) of tabs"
        :key="`tab-${$index}`"
        @click="gotoSlick($index)"
      >
        <p>
          {{ tab.label }}
        </p>
        <div class="current-module" v-if="$index == currentIndex"></div>
      </div>
    </div>
    <div class="modulos__tabs is-hidden-desktop">
      <div class="tab">
        <p>
          {{ tabs[currentIndex].label }}
        </p>
        <div class="current-module"></div>
      </div>
    </div>
    <!-- <slither-slider :options="options" @changed="currentIndexFunc($event)">
      <div
        class="slide columns"
        v-for="(slide, $index) in slides"
        :key="`slide-${$index}`"
      >
        <div class="slide__text column is-half">
          <h3 v-html="slide.title"></h3>
          <p v-html="slide.text"></p>
          <a
            @click="$router.push({ name: slide.action })"
            class="button is-rounded bg-primary-dark"
          >
            Ver más
          </a>
        </div>
        <div class="slide__image column column-50">
          <img :src="slide.image" alt="" />
        </div>
      </div>
      <template slot="previous">
        &lang;
      </template>
      <template slot="next">
        &rang;
      </template>
    </slither-slider> -->
    <slick ref="slick" :options="options" @afterChange="currentIndexFunc">
      <div
        class="slidex columns"
        v-for="(slide, $index) in slides"
        :key="`slide-${$index}`"
      >
        <div class="slidex__image column column-50">
          <img :src="slide.image" alt="" />
        </div>
        <div class="slidex__text column is-half-tablet">
          <h3 v-html="slide.title"></h3>
          <p v-html="slide.text"></p>
          <a
            @click="$router.push({ name: slide.action })"
            class="button is-rounded bg-primary-dark"
          >
            Ver más
          </a>
        </div>
      </div>
    </slick>
    <div class="arrows">
      <img
        src="../assets/images/arrow-left.svg"
        class="arrows-prev-module"
        alt=""
        @click="prevSlick"
      />
      <img
        src="../assets/images/arrow-right.svg"
        class="arrows-next-module"
        alt=""
        @click="nextSlick"
      />
    </div>
  </section>
</template>

<script>
import Slick from "vue-slick";
import "../../node_modules/slick-carousel/slick/slick.css";
export default {
  name: "ModulosCarrousel",
  components: {
    Slick
  },
  data() {
    return {
      currentIndex: 0,
      options: {
        infinite: true,
        dots: true,
        arrows: false,
        prevArrow: ".arrows-prev-module",
        nextArrow: ".arrows-next-module",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              infinite: true,
              dots: true,
              arrows: true,
              prevArrow: ".arrows-prev-module",
              nextArrow: ".arrows-next-module"
            }
          },
          {
            breakpoint: 1024,
            settings: {
              infinite: true,
              dots: true,
              arrows: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              infinite: true,
              arrows: false
              // dots: false,
              // arrows: false,
              // prevArrow: ".arrows-prev-module",
              // nextArrow: ".arrows-next-module",
            }
          },
          {
            breakpoint: 320,
            settings: {
              infinite: true,
              arrows: false
              // dots: false,
              // arrows: false,
              // prevArrow: ".arrows-prev-module",
              // nextArrow: ".arrows-next-module",
            }
          }
        ]
      },
      tabs: [
        {
          label: "Ventas",
          action: ""
        },
        // {
        //   label: "Cotizaciones",
        //   action: ""
        // },
        // {
        //   label: "Guías de Remisión",
        //   action: ""
        // },
        {
          label: "Clientes y Proveedores",
          action: ""
        },
        {
          label: "Gastos y Compras",
          action: ""
        },
        {
          label: "Inventario",
          action: ""
        },
        {
          label: "Reportes",
          action: ""
        }
      ],
      slides: [
        {
          title:
            'Crea comprobantes de venta<br class="not-mobile" /> electrónicas en segundos desde<br class="not-mobile" /> cualquier lugar y desde cualquier<br class="not-mobile" /> dispositivo',
          text:
            'ContaFácil permite crear <br class="not-mobile" />comprobantes personalizados con el<br class="not-mobile" /> logo de tu empresa de la forma más<br class="not-mobile" /> simple.',
          action: "sales",
          image: require("../assets/images/ventas-slick.svg")
        },
        // {
        //   title: `Crea expectatias claras para <br class="is-hidden-touch" />tus clientes y conviértelas a <br class="is-hidden-touch" />ventas`,
        //   text: `Genera cotizaciones sencillas, formales y<br class="is-hidden-touch"/> acelera tu proceso para generar una nueva <br class="is-hidden-touch"/>venta . Elimina cualquier duda en la relación <br class="is-hidden-touch"/>con tu cliente`,
        //   action: "marketrates",
        //   image: require("../assets/images/cotizaciones-slick.svg")
        // },
        // {
        //   title: `Guías de remisión en tan solo <br class="is-hidden-touch" />
        //     unos pasos`,
        //   text: `Emite guías de remisión <br class="is-hidden-touch" />
        //     electrónica de forma fácil y rápida. <br class="is-hidden-touch"/>
        //     Si tienes comprobantes de <br class="is-hidden-touch" />
        //     venta relacionados se jalará <br class="is-hidden-touch" />
        //     automáticamente la <br class="is-hidden-touch" />
        //     información de productos a <br class="is-hidden-touch" />
        //     transportar y del comprobante.`,
        //   action: "referralguide",
        //   image: require("../assets/images/guia-slick.svg")
        // },
        {
          title: `ContaFácil seguimiento<br class="is-hidden-touch"> continuo`,
          text: `ContaFácil permite seguimiento<br class="is-hidden-touch"> continuo de las operaciones con tus <br class="is-hidden-touch"/>
          <b>clientes y proveedores</b>. Envía <br class="is-hidden-touch">recordatorios y alertas para que te <br class="is-hidden-touch">paguen a tiempo. Mantente actualizado <br class="is-hidden-touch">sobre el estado de tu negocio.`,
          action: "client-provider",
          image: require("../assets/images/clientes-slick.svg")
        },
        {
          title: `Organiza tus gastos corrientes y <br class="is-hidden-touch"/>
            costos sin esfuerzo`,
          text: `ContaFácil permite un monitoreo continuo y <br class="is-hidden-touch"/>
            actualizado de los estados de cuenta! Te da <br class="is-hidden-touch"/>
            una mirada real y al instante del negocio.`,
          action: "expenses-purchases",
          image: require("../assets/images/compras-slick.svg")
        },
        {
          title: `Administra tus productos <br class="is-hidden-touch">en un solo lugar`,
          text: `ContaFácil permite administrar <br class="is-hidden-touch"/>productos en cada punto de venta. <br class="is-hidden-touch"/> Envío de alertas de stock por <br class="is-hidden-touch"/>agotarse, fuera de stock y lote con <br class="is-hidden-touch"/>fecha de vencimiento expirada.`,
          action: "inventory",
          image: require("../assets/images/inventario-slick.svg")
        },
        {
          title: `Reportes claros y sencillo que <br class="is-hidden-touch"/>te dan
            información actualizada <br class="is-hidden-touch"/>de tu negocio`,
          text: `Olvidate de los dolores de <br class="is-hidden-touch"/>
            cabeza para cuadrar tus <br class="is-hidden-touch"/>
            operaciones al final del día. <br class="is-hidden-touch"/>
            ContaFácil permite saber el <br class="is-hidden-touch"/>
            estado de tu negocio al <br class="is-hidden-touch"/>
            instante.`,
          action: "reports",
          image: require("../assets/images/reportes-slick.svg")
        }
      ]
    };
  },
  methods: {
    currentIndexFunc(event, slick, currentSlide) {
      // console.log($e);
      // console.log("en currentIndexFunc");
      console.log(currentSlide);
      this.currentIndex = currentSlide;
    },
    nextSlick() {
      this.$refs.slick.next();
    },
    prevSlick() {
      this.$refs.slick.prev();
    },
    gotoSlick(index) {
      this.$refs.slick.goTo(index);
    }
  }
};
</script>

<style lang="scss">
@import "../../node_modules/slither-slider/plugin-dist/slither-slider.css";
@import "../assets/styles/general";
.slither-slider {
  position: relative;
  padding: 0 1rem;
  .slither-slider-controls {
    position: absolute;
    z-index: 0;
    top: 40%;
    left: 0px;
    right: 0px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.5rem;
    & > div {
      font-size: 3rem;
      color: #9e9e9e;
      cursor: pointer;
      transition: all 0.1s;
      &:hover {
        color: #000000;
      }
    }
  }
}

.arrows {
  display: none;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 50%;
  left: -1%;
  right: -1%;
  z-index: 3;
  &-prev,
  &-next {
    cursor: pointer;
  }
  &-prev-blog,
  &-next-blog {
    cursor: pointer;
    transform: scaleX(0.3);
  }
  &-prev-module,
  &-next-module {
    cursor: pointer;
    // transform: scaleX(0.3);
  }
  &-prev-plan,
  &-next-plan {
    cursor: pointer;
  }
  &-next-module {
    transform: scaleX(0.3) translateX(30px);
  }
  &-prev-module {
    transform: scaleX(0.3) translateX(-30px);
  }
  &-next-blog {
    transform: scaleX(0.3) translateX(50px);
  }
  &-prev-blog {
    transform: scaleX(0.3) translateX(-50px);
  }
  &-next-plan {
    transform: scaleX(0.3) translateX(95px);
  }
  &-prev-plan {
    transform: scaleX(0.3) translateX(-95px);
  }
  @include desktop() {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    left: -5%;
    right: -5%;
    &-prev,
    &-next {
      cursor: pointer;
    }
    &-prev-blog,
    &-next-blog {
      cursor: pointer;
      transform: none;
    }
    &-prev-module,
    &-next-module {
      cursor: pointer;
      transform: none;
    }
    &-prev-plan,
    &-next-plan {
      cursor: pointer;
      transform: none;
    }
  }
}
// .slick-prev:before,
// .slick-next:before {
//   font-family: "slick";
//   font-size: 30px;
//   line-height: 1;
//   opacity: 0.75;
//   color: #8a57af;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
// }
</style>

<style lang="scss" scoped>
@import "../assets/styles/general.scss";
// @import "../../node_modules/slither-slider/plugin-dist/slither-slider.css";
// @import "../../node_modules/slick-carousel/slick/slick.css";
.modulos {
  margin: 3rem auto;
  width: 90%;
  overflow: visible;
  position: relative;
  @include laptop() {
    width: 80%;
    margin-bottom: 10rem;
  }
  &__tabs {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-evenly;
    align-items: center;
    padding: 1em;
    .tab {
      position: relative;
      cursor: pointer;
      .current-module {
        // border-bottom: 7.5px solid $primary;
        position: absolute;
        // right: calc(50% - 52.5px);
        transform: translateX(50%);
        bottom: -6px;
        height: 7px;
        width: 50%;
        background-color: $primary;
        transition: all 0.2ms;
      }
    }
    p {
      transition: all 0.3s;
      font-size: 16px;
      padding-bottom: 1rem;
    }

    @include tablet() {
    }
    @media (min-width: 900px) {
      p {
        font-size: 16px;
        letter-spacing: 0.075em;
      }
    }
    @include laptop() {
      display: flex;
      p {
        font-size: 0.8rem;
      }
    }
    @include desktop() {
      p {
        font-size: 1rem;
      }
    }
    @include desktop-medium() {
      p {
        font-size: 1.2rem;
      }
    }
    @include desktop-large() {
      p {
        font-size: 1.6rem;
      }
    }
  }
  .columns {
    @include laptop() {
      display: flex !important;
      margin: 0px !important;
      flex-direction: row-reverse;
    }
  }
  .slidex {
    padding: 3rem 0.75rem;
    z-index: 1;
    &__text {
      h3 {
        color: $titles-videos-color;
        font-size: 14px;
        letter-spacing: 0.05em;
        font-weight: 600;
      }
      p {
        font-size: 14px;
        letter-spacing: 0.03em;
        margin: 1em 0;
      }
      .button {
        text-align: center;
        // font-size: 1.5rem;
        font-size: 14px;
        font-weight: normal;
        letter-spacing: 0.015em;
        padding: 0 1.5rem;
      }
      // @media (max-width: 767px) {
      //   min-width: 100%;
      // }
      @include tablet() {
        text-align: center;
        h3 {
          // color: $primary;
          letter-spacing: 0.015em;
          font-size: 1.4rem;
          font-weight: 500;
        }
        p {
          font-size: 1.4rem;
          letter-spacing: 0.015em;
        }
        .button {
          font-size: 1rem;
          font-weight: normal;
          letter-spacing: 0.015em;
          padding: 0 3rem;
        }
      }
      @include laptop() {
        text-align: start;
        display: flex;
        justify-content: center;
        flex-flow: column;
        // text-align: center;
        h3 {
          // color: $primary;
          letter-spacing: 0.015em;
          font-size: 1.2rem;
          font-weight: 600;
        }
        p {
          font-size: 1.2rem;
          letter-spacing: 0.025em;
        }
        .button {
          font-size: 1.2rem;
          font-weight: bold;
          letter-spacing: 0.015em;
          padding: 0 3rem;
          max-width: 150px;
        }
      }
      @include desktop() {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        h3,
        p {
          font-size: 1.4rem;
          line-height: 1.2;
        }
        .button {
          text-align: center;
          font-size: 1rem;
          font-weight: bold;
          letter-spacing: 0.015em;
          padding: 0 1.5rem;
        }
      }
      @include desktop-large() {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        h3,
        p {
          font-size: 1.6rem;
          line-height: 1;
        }
        .button {
          text-align: center;
          // display: block;
          max-width: none;
          font-size: 1.3rem;
          font-weight: bold;
          letter-spacing: 0.015em;
          padding: 0 2em;
          margin: 2rem 0;
          width: fit-content;
        }
      }
    }
    &__image {
      img {
        width: 100%;
        height: auto;
        // margin: 2em 0;
      }
      @include tablet() {
        margin-left: auto;
        max-height: 400px;
        height: 100%;
        margin: 2em auto;
        img {
          height: 400px;
          width: 100%;
        }
      }
      @media (min-width: 1024px) {
        margin-left: auto;
        max-height: 400px;
        height: 100%;
        margin: 0 auto;
        img {
          // height: 400px;
          width: 100%;
        }
      }
    }
    @include laptop() {
      height: 500px;
    }
  }
}
</style>
